import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import PageNavigation from "./page";


export default function DescribeImage() {

  const [describeImageData, setDescribeImageData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDescribeImageData = async () => {
      try {
        const response = await fetch("/api/questions/describeimage", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setDescribeImageData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch Readaloud data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching Readaloud data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchDescribeImageData();
  }, []); // Empty dependency array to fetch data only once on mount
  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading="Describe Image" id={describeImageData.data}/>
    </div>
  );
}
